module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-It.b400729.woff";